var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkeletonImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504 504",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M484.312,82.688H19.688C8.812,82.688,0,91.5,0,102.376v299.248c0,10.876,8.812,19.688,19.688,19.688h464.624 c10.876,0,19.688-8.812,19.688-19.688V102.376C504,91.5,495.188,82.688,484.312,82.688z M391.5,217.392l-74.456,74.476 L203.712,178.54c-1.536-1.536-4.024-1.536-5.564,0l-71.884,71.888l-32.816-32.812c-1.536-1.54-4.172-1.54-5.708,0l-52.304,52.156 V118.124H468.56v170.788l-71.5-71.52C395.52,215.852,393.04,215.852,391.5,217.392z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M311.3,153.58c-15.304,0-27.752,12.444-27.752,27.748c0.004,15.3,12.452,27.752,27.752,27.752 s27.752-12.448,27.752-27.752C339.052,166.028,326.604,153.58,311.3,153.58z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeletonImg);
export default __webpack_public_path__ + "static/media/skeleton-img.5ab3ebeb9ebd06da0dffc3d07224af30.svg";
export { ForwardRef as ReactComponent };